import loader from "./loader.vue";
export default loader;
